import cn from 'classnames'
import React, { ComponentProps } from 'react'

type CheckCircleFilledIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function CheckCircleFilledIcon(
  props: CheckCircleFilledIconProps,
) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('CheckCircleFilledIcon', className)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...rest}
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="#23B998"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M6.10437 9.74992L8.70854 12.3541L13.396 7.14575"
        stroke="white"
        strokeWidth="2.08333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
